<template>
    <div>
      <h1>Error Page</h1>
      <p>Something went wrong!</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Error',
  }
  </script>
  
  <style scoped>
  h1 {
    color: red;
  }
  </style>
